module.exports = __webpack_public_path__ + "img/gallery-img-2s.aa1f8010.jpg";